import { render, staticRenderFns } from "./ParticipantProfile.vue?vue&type=template&id=affb5c0a&scoped=true&"
import script from "./ParticipantProfile.vue?vue&type=script&lang=js&"
export * from "./ParticipantProfile.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantProfile.vue?vue&type=style&index=0&id=affb5c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb5c0a",
  null
  
)

export default component.exports